import plugin from 'tailwindcss/plugin'

export default plugin(({ addUtilities }) => {
  addUtilities({
    '.break-word-legacy': {
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
    },
  })
})
